import React from 'react'

import { IMessage } from 'component-library-next'

import { LawyerDocument } from '@app/graphql/types'
import { bemJoin } from '@app/lib/bem'
import { ModernChat } from '@app/lib/components/ModernChat'
import { DocumentsList } from '@app/lib/display/DocumentsList/DocumentsList'
import { CourtCaseMessageFragment } from '@app/queries/CourtCases/CourtCase.queries'

import './styles.scss'

type Props = {
  message: CourtCaseMessageFragment
}

export const CourtCaseLawyer = ({ message }: Props) => {
  const b = bemJoin('court-case-lawyer')

  return (
    <div className={b()}>
      <ModernChat
        collapsesLongText={true}
        displayLetterRequest={false}
        message={{ ...message, documents: [], type: 'Answer' } as IMessage}
      >
        {message.documents && <DocumentsList documents={message.documents as LawyerDocument[]} />}
      </ModernChat>
    </div>
  )
}
